import React from 'react'
import KnowledgebaseContainer from '../../../Components/Miscellaneous/Knowledgebase'

export default function Knowledgebase() {
    return (
        <div className='page-body'>
            <KnowledgebaseContainer />
        </div>
    )
}
